/**
 * `challenge_done` is the API telling us the student already finished this
 * challenge in a journey that blocks redo — the outcome the caller wanted is
 * already true. Showing it as an error stops the student on a step they cannot
 * pass, which is exactly the reported bug, so the flow treats it as success and
 * moves on.
 *
 * Raised by ProgressService::ChallengeFinisher#ensure_redo_allowed! with HTTP
 * 422 and `{ error_message: 'challenge_done' }`.
 */
export function isChallengeDoneError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false

  const response = (error as { response?: { data?: { error_message?: unknown } } })
    .response

  return response?.data?.error_message === 'challenge_done'
}
